import SockJS from "sockjs-client";
import { Stomp as StompJs } from "@stomp/stompjs";
import { environment } from "../../config/environment";
import { SUB_SOCKET_FB_PAGE } from "../../config/config";
import { store } from "../../store";
import { receiveMessages } from "../../store/action/commentAction";
import { SUB_FB_PAGE } from "./constant";
import { replaceNavigate } from "./Helper";
import { MessageUltis } from "./MessageUltis";
import { messageSocket } from "../../store/action/conversationAction";

class Stomp {
   isConnected = false;
   isSub = false;

   constructor() {
      if (Stomp.instance) {
         return Stomp.instance;
      }
      // Các thuộc tính và phương thức khởi tạo
      this.isConnected = false;
      this.isSub = false;
      this.pageSub = '';
      this.stomp = null;
      Stomp.instance = this;
   }

   async _connect() {
      if (this.isConnected && this.stomp) {
         return Promise.resolve(true);
      }
      const { getState } = store;
      const { user } = getState();
      const socket = new SockJS(environment.API_WS_BOT);
      this.stomp = StompJs.over(socket);
      this.stomp.debug = (e) => {
         console.log('Socket Debug: ', e);
      };

      this.stomp.reconnectDelay = 3000;
      this.stomp.onWebSocketClose = this.onWebSocketClose;
      this.stomp.onWebSocketError = this.onWebSocketError;
      this.stomp.onDisconnect = this.onDisconnected;
      return new Promise((resolve, reject) => {
         this.stomp.connect({
            Authorization: `${user.userAccessToken}`
         },
            (frame) => {
               this.onConnected(frame);
               resolve(frame);
            },
            (frame) => {
               this.onDisconnected(frame);
               reject(false);
            }
         )
      });
   }

   _disconnect() {

   }

   subscribe(sub) {
      if (this.isConnected) {
         const destination = replaceNavigate(SUB_FB_PAGE, sub, ':fb_page_id');
         if (this.isSub) {
            if (this.pageSub !== sub) {
               this.unsubscribe(this.pageSub);
               this.isSub = true;
               this.pageSub = sub;
               return this.stomp.subscribe(destination, this.onSubMessage);
            }
         } else {
            this.isSub = true;
            this.pageSub = sub;
            return this.stomp.subscribe(destination, this.onSubMessage);
         }
      } else {
         console.error('Cannot subscribe, not connected.');
      }
   }

   unsubscribe(sub) {
      const destionationOld = replaceNavigate(SUB_FB_PAGE, this.pageSub, ':fb_page_id');
      this.stomp.unsubscribe(destionationOld);
      this.isSub = false;
   }

   onConnected(frame) {
      console.log('onConnected', frame);
      this.isConnected = true;
   }

   onDisconnected(frame) {
      this.isConnected = false;
      this.stomp = null;
      console.log('Socket onDisconnected: ', frame);
   }

   onWebSocketClose(e) {
      this.isConnected = false;
      this.stomp = null;
      console.log('Socket onWebSocketClose: ', e);
   }

   onWebSocketError(e) {
      this.isConnected = false;
      this.stomp = null;
      console.log('Socket onWebSocketError:  ', e);
   }

   onSubMessage(msg) {
      const { dispatch } = store;
      const body = msg.body;
      const message = MessageUltis.formaterMessage(body);
      console.log('onSubMessage', message);
      dispatch(messageSocket(message));
   }
}

export default Stomp;